import axios from 'axios';
import { ROOT_URL } from '../../../actions/root_url';

export function fetchSalesPerformanceData(type, groupId = null, categoryId = null) {
  const url = `${ROOT_URL}v1/dashboard/category_analysis/chart`;
  const params = {
    type,
  };
  if (groupId) params.group = groupId;
  if (categoryId) params.category = categoryId;

  return axios({
    method: 'get',
    url,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    params,
  });
}



// WEBPACK FOOTER //
// ./master/jsx/components/General/CategoryAnalysis/utils.js